module.exports = __webpack_public_path__ + "img/zz-row-five.384a8bca.svg";